var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4277",
    "data-name": "Group 4277",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M0,0H23V23H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M6.833,5.833V2.958A.958.958,0,0,1,7.792,2h11.5a.958.958,0,0,1,.958.958V16.375a.958.958,0,0,1-.958.958H16.417v2.875a.961.961,0,0,1-.965.958H3.965A.959.959,0,0,1,3,20.208L3,6.792a.961.961,0,0,1,.965-.958ZM4.92,7.75l0,11.5H14.5V7.75ZM8.75,5.833h7.667v9.583h1.917V3.917H8.75Z",
    transform: "translate(-0.125 -0.083)",
    fill: "#32d172"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3e33d1520213ca80d16d0537c737b87e.svg";
export { ForwardRef as ReactComponent };